import controller from './buy.controller';

export default {
  bindings: {
    /* from resolve section */
    packet: '<',
    invoice: '<'
  },
  controller,
  template: require('./buy.html')
};



// WEBPACK FOOTER //
// src/app/buy/buy.component.ts